module.exports = __webpack_public_path__ + "img/cookie.6906b53b.png";